import { Component, ViewEncapsulation } from '@angular/core';
import { DocumentPanelRootService } from './document-panel-root.service';

// todo obsolete after releasing
// https://chainformation.atlassian.net/browse/FI-6159
@Component({
    selector: 'fi-document-panel-root',
    template:
        '<ng-container *ngComponentOutlet="documentPanelRootService.panelComponent; injector: documentPanelRootService.panelInjector"></ng-container>',
    styleUrls: ['./document-panel-root.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DocumentPanelRootComponent {
    constructor(public documentPanelRootService: DocumentPanelRootService) {}
}
